// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subheader[data-v-cfed1a60] {
  font-size: 16px;
}
.substep-number[data-v-cfed1a60] {
  border-radius: 50%;
  background: #4D52E5;
  width: 40px;
  height: 40px;
  color: white;
  text-align: center;
  line-height: 40px;
  font-weight: 800;
  font-size: 20px;
}
.scroll[data-v-cfed1a60] {
  max-height: 500px;
  overflow-y: auto;
}
.column-container[data-v-cfed1a60] {
  margin-top: 0;
}
.download-col[data-v-cfed1a60], .edit-col[data-v-cfed1a60], .upload-col[data-v-cfed1a60] {
  max-width: 318px;
}
.example-text[data-v-cfed1a60] {
  font-size: 11px;
  font-style: italic;
}`, "",{"version":3,"sources":["webpack://./js/modules/admin/components/BuildingsSpaces/StartingGuide.vue","webpack://./StartingGuide.vue"],"names":[],"mappings":"AACA;EACE,eAAA;ACAF;ADEA;EACE,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;ACCF;ADCA;EACE,iBAAA;EACA,gBAAA;ACEF;ADAA;EACE,aAAA;ACGF;ADDA;EACE,gBAAA;ACIF;ADFA;EACE,eAAA;EACA,kBAAA;ACKF","sourcesContent":["\n.subheader {\n  font-size: 16px;\n}\n.substep-number {\n  border-radius: 50%;\n  background:  #4D52E5;\n  width: 40px;\n  height: 40px;\n  color: white;\n  text-align: center;\n  line-height: 40px;\n  font-weight: 800;\n  font-size: 20px;\n}\n.scroll {\n  max-height: 500px;\n  overflow-y: auto;\n}\n.column-container {\n  margin-top: 0;\n}\n.download-col, .edit-col, .upload-col {\n  max-width: 318px;\n}\n.example-text {\n  font-size: 11px;\n  font-style: italic;\n}\n",".subheader {\n  font-size: 16px;\n}\n\n.substep-number {\n  border-radius: 50%;\n  background: #4D52E5;\n  width: 40px;\n  height: 40px;\n  color: white;\n  text-align: center;\n  line-height: 40px;\n  font-weight: 800;\n  font-size: 20px;\n}\n\n.scroll {\n  max-height: 500px;\n  overflow-y: auto;\n}\n\n.column-container {\n  margin-top: 0;\n}\n\n.download-col, .edit-col, .upload-col {\n  max-width: 318px;\n}\n\n.example-text {\n  font-size: 11px;\n  font-style: italic;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
